<template>
	<el-tabs v-model="activeTab" type="border-card" class="w-100" closable @tab-remove="removeTab" style="height: 100%">
		<el-tab-pane v-for="(tab, index) in tabs_" :key="index" :label="tab.sqlId" :name="index + ''" style="height: 100%">
			<template slot="label">
				<span class="csBg" v-if="tab.serviceProgram === 'CSharp'">● {{ tab.sqlId }}</span>
				<span class="javaBg" v-if="tab.serviceProgram === 'Java'">● {{ tab.sqlId }}</span>
			</template>
			<sf-card class="border-0 bg-transparent h-100">
				<table-container :mainIndex="tab.sqlId" class="h-100"></table-container>
				<popup-table />
			</sf-card>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';
import TableContainer from './TableContainer.vue';
import PopupTable from '../Popup/PopupTable.vue';

export default {
	components: { TableContainer, PopupTable },
	data() {
		return {
			activeTab: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		tabs() {
			return this.sqlContent;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		removeTab(tabNum) {
			//console.log('@@remove tab===>', tabNum);
			const closeIndex = tabNum;
			//console.log('@@sqlContent', this.sqlContent);
			this.sqlContent.splice(closeIndex, 1);
			this.DEFAULT_ASSIGN({
				key: 'sqlContent',
				value: this.sqlContent
			});
		}
	},
	watch: {
		tabs() {
			this.activeTab = this.sqlContent.length - 1 + '';
		},
		activeTab() {
			this.DEFAULT_ASSIGN({
				key: 'selectedContent',
				value: this.tabs_[this.activeTab]
			});
		}
	}
};
</script>

<style>
.main-section-container {
	/* width: 20%; */
	display: flex;
	/* height: 75vh; */
	flex-direction: column;
	background-color: #ffffff;
	/* overflow-y: auto; */
	margin-left: 10px;
}
.csBg {
	color: blue;
	font-weight: bold;
}
.javaBg {
	color: green;
	font-weight: bold;
}
</style>
